import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const { value } = control;
        if (!value) {
            return null;
        }

        const emailRegex = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/u;
        return emailRegex.test(value) ? null : { email: value };
    };
}